import { render, staticRenderFns } from "./PopularCategoryCard.vue?vue&type=template&id=d5f30564&scoped=true"
import script from "./PopularCategoryCard.vue?vue&type=script&lang=js"
export * from "./PopularCategoryCard.vue?vue&type=script&lang=js"
import style0 from "./PopularCategoryCard.vue?vue&type=style&index=0&id=d5f30564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f30564",
  null
  
)

export default component.exports